<template>
  <div id="wrapper">
    <Nav :message="message" />
    <AbsenceReport />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import AbsenceReport from '@/components/dashboard/AbsenceReport.vue'

export default {
  name: 'Absence',
  props: ['message'],
  components: {
    Nav,
    AbsenceReport
  }
}
</script>